import { createFileRoute } from "@tanstack/react-router";
import { Page } from "#/components/page";

// Portal parity: `_protected.$school.faq` renders an empty `Page` shell (content TBD).
// Portal also wired a route-level `ErrorBoundary`; in TanStack the root route's error boundary
// covers this, so no per-route errorComponent is ported.
export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/$school/faq")({
  component: FaqPage,
});

function FaqPage() {
  return <Page />;
}
